import App from './App.vue';
import router from './router';
import { clear_token } from './router';
import { createApp } from 'vue';
import SessionTimeoutPrompt from "@/components/SessionTimeoutPrompt/SessionTimeoutPrompt.vue";
import LandingBackgroundVideo from "@/components/LandingBackgroundVideo/LandingBackgroundVideo.vue";

// Popper.js is a Bootstrap dependency
import 'bootstrap';
 
 
// Bootstrap JS + CSS (v4)
import 'bootstrap/dist/js/bootstrap.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
 
// Import Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
 
// Import Font Awesome
import "@fortawesome/fontawesome-free/css/all.css";
 
// Import Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css";
 
// Import custom CSS
import './assets/style/style.css';
 
 
const jquery_instance = window.jQuery || window.$;
const public_auth_paths = new Set([
  "/",
  "/login",
  "/one_time_pin",
  "/reset_password",
  "/reset-password",
  "/password_reset_confirm",
  "/password_reset_complete"
]);

if (jquery_instance) {
  jquery_instance(document).ajaxComplete(function(event, xhr) {
    if (xhr.status === 401 && !public_auth_paths.has(router.currentRoute.value.path)) {
      clear_token();
      router.replace("/login");
    }
  });
}
const app = createApp(App);

app.component("LandingBackgroundVideo", LandingBackgroundVideo);
app.component("SessionTimeoutPrompt", SessionTimeoutPrompt);
app.use(router).mount('#app');
 
